import React, { useEffect } from "react";

import "./Mechdept.css";
import "./Mech_asso.css";
import {
  Backtotop,
  Floatinmenu,
  Underline,
  Deptmission,
  Deptvision,
  ContentCard,
  Reunion_card,
} from "../../widgets";
import {
  mech_dept_menu,
  mech_mission,
  mech_vision,
  mech_progs,
  mech_asso,
  shackles,
  mech_iv,
  mech_asso_achievements,
} from "../../constants/mech_dept";

import { Modal_carousel } from "../../components";

import EventShowcase from "../../containers/EventShowcase/EventShowcase";

import { RadialMenu, Hodmsg } from "../../components";

import { BsFillGearFill } from "react-icons/bs";
import Mech_achievements from "./Mech_achievements";
const mech =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/mech/mech_cover.webp";

const Mechasso = () => {
  useEffect(() => {
    document.title = "ACCET-Mech Department";
  }, []);
  return (
    <div className="mechdept">
      <div className="mechbg">
        <div className="mechheading">Department of Mechanical Engineering</div>
      </div>
      <section className="mechdark">
        <div className="dept_float_menu">
          <Floatinmenu
            logo={BsFillGearFill}
            head="Menu"
            links={mech_dept_menu}
          />
        </div>
        <RadialMenu menu_links={mech_dept_menu} />
        <Underline heading="About the MEA"></Underline>
        <div className="mech_asso_abt">
          <Hodmsg
            name={mech_asso.name}
            designation={mech_asso.designation}
            pic={mech_asso.pic}
            content={mech_asso.content}
          />
        </div>
        <div className="mech_asso_event_content">
          <EventShowcase
            key={shackles[0].id}
            heading={shackles[0].heading}
            date={shackles[0].date}
            organizer={shackles[0].organizer}
            content={shackles[0].content}
            images={shackles[0].images}
          />
        </div>

        <Underline heading="Industrial Visits"></Underline>
        <div className="mech_iv_events_holder">
          {mech_iv.map((item) => (
            <Reunion_card
              margin_bw={20}
              cover={item.pic}
              name={item.heading}
              date={item["sub-head"]}
            />
          ))}
        </div>

        <Underline heading="Student Achievements"></Underline>
        <div className="mech_asso_achievements">
          <Modal_carousel info={mech_asso_achievements} />
        </div>
      </section>

      <Backtotop />
    </div>
  );
};

export default Mechasso;
